<template>
  <div role="tablist" class="mt-3" id="listCliente">
    <div>
      <b-card-header
        header="Lista de Clientes"
        header-text-variant="white"
        header-tag="header"
        :style="cor"
      />
      <b-card no-body class="mb-1 shadow b-radius-0 p-3">
        <b-card-body class="table">
          <b-table bordered striped :items="clientes" :fields="fields" class="verticalAlign" v-if="this.clientes.length > 0">
            <template slot="mobile" slot-scope="row">
              <div class="form-row mb-1">
                <div class="col-md-8"><strong>{{toCapitalize(row.item.fantasia)}}</strong></div>
                <div class="col-md-4"><strong>Cód.: {{row.item.codCliente}}</strong></div>
              </div>
              <div class="form-row mb-1">{{toCapitalize(row.item.razaoSocial)}}</div>
              <div class="form-row mb-1" v-if="row.item.cnpjCpf.length === 14">CNPJ: {{formatterCnpjCpf(row.item.cnpjCpf)}}</div>
              <div class="form-row mb-1" v-else>CPF: {{formatterCnpjCpf(row.item.cnpjCpf)}}</div>
              <div class="form-row mb-1">Endereço: {{toCapitalize(row.item.endereco)}} - {{toCapitalize(row.item.cidade)}} - {{row.item.uf}}</div>
            </template>
            <template slot="actions" slot-scope="row">
              <b-button size="sm" @click="selecionar(row.item)" class="mr-1">
                Selecionar
              </b-button>
            </template>
          </b-table>
          <span v-else>
            Não foram encontrados clientes com os termos pesquisados, tente novamente
          </span>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>
<script>
  import clientes from '@/services/tableClientes'
  import { broadcastServer, modo, operacao } from '@/main'
  // import NewItemsClientesVue from '@/components/items/NewItemsClientesVue'
  export default {
    props: ['title'],
    data () {
      return {
        cor: '',
        clientes: [],
        uf: '',
        termo: '',
        cidade: '',
        // Note 'isActive' is left out and will not appear in the rendered table
        fields: [
          {
            key: 'codCliente',
            label: 'Cód. Cli.',
            sortable: true,
            class: 'cliListCod txtLeft'
          },
          {
            key: 'fantasia',
            label: 'Fantasia',
            sortable: true,
            class: 'cliListCod txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'razaoSocial',
            label: 'Razão Social',
            sortable: true,
            class: 'cliListRaz txtLeft',
            formatter: this.toCapitalize
          },
          // {
          //   key: 'cnpjCpf',
          //   label: 'CNPJ/CPF',
          //   sortable: true,
          //   class: 'cliListCnpj txtLeft'
          // },
          {
            key: 'endereco',
            label: 'Endereço',
            sortable: true,
            class: 'cliListEnd txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'uf',
            label: 'UF',
            sortable: true,
            class: 'cliListUf txtLeft'
          },
          {
            key: 'cidade',
            label: 'Cidade',
            sortable: true,
            class: 'cliListCid txtLeft',
            formatter: this.toCapitalize
          },
          {
            label: '',
            key: 'mobile',
            class: 'cliListMobile txtLeft'
          },
          {
            label: 'Ação',
            key: 'actions',
            class: 'cliListAcoes'
          }
        ]
      }
    },
    created () {
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
      this.corComp = {'style: background-color': `#${localStorage.getItem('corApp')}`}
      broadcastServer.$on('parametrosSelecionadosCliente', (parametros) => {
        // console.log('filtros: ' + JSON.stringify(parametros))
        this.listar(parametros)
      })
    },
    mounted () {
      // NewItemsClientesVue.$refs.btnAdicionar.innerText = 'leticia'
      let parametros = {termo: this.termo, uf: this.uf, cidade: this.cidade}
      this.listar(parametros)
    },
    methods: {
      selecionar: function (cliente) {
        cliente.cnpjCpf = cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '').replace('-', '')
        // console.log(JSON.stringify(cliente))
        broadcastServer.$emit('clienteSelecionado', cliente)
        // broadcastServer.$emit('clienteSelecionado', cliente)
      },
      listar: function (parametros) {
        clientes.listarSelect(parametros).then(response => {
          this.clientes = response.data.clientes
        })
      },
      info: function (item, index) {
        // console.log(`item: ${item.codCliente}`)
        let parametro = {operacao: operacao.ALTERAR, modo: modo.EDICAO}
        broadcastServer.$emit('pageEditClientes', parametro)
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      formatterCnpjCpf: function (value) {
        if (value.length === 14) {
          value = value.replace(/^(\d{2})(\d)/, '$1.$2')
          value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          value = value.replace(/\.(\d{3})(\d)/, '.$1/$2')
          value = value.replace(/(\d{4})(\d)/, '$1-$2')
          return value
        }
        if (value.length === 11) {
          value = value.replace(/(\d{3})(\d)/, '$1.$2')
          value = value.replace(/(\d{3})(\d)/, '$1.$2')
          value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
          return value
        }
      }
    }
  }
</script>
<style scoped>
  .b-table {
    font-size: 14px;
  }
  .table {
    overflow-y: auto;
    max-height: 350px;
    font-size: 14px;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/TableAcoesVue.vue